export const passwordActions = {
  RESET_PASSWORD: {
    REQUEST: 'pharmacy-reset-password/reset-password-request',
    SUCCESS: 'pharmacy-reset-password/reset-password-success',
    FAILURE: 'pharmacy-reset-password/reset-password-failure'
  },
  CONFIRM_RESET_PASSWORD: {
    REQUEST: 'pharmacy-reset-password/confirm-reset-password-request',
    SUCCESS: 'pharmacy-reset-password/confirm-reset-password-success',
    FAILURE: 'pharmacy-reset-password/confirm-reset-password-failure'
  }
};
